import { render } from "./transaction-related.vue?vue&type=template&id=3e4bffe4&scoped=true"
import script from "./transaction-related.vue?vue&type=script&lang=js"
export * from "./transaction-related.vue?vue&type=script&lang=js"

import "./transaction-related.vue?vue&type=style&index=0&id=3e4bffe4&lang=less&scoped=true"

import exportComponent from "/Users/jixubin/yunsi/bzcircle-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e4bffe4"]])

export default __exports__